'use client'
import { checkLocalStorage } from './utils'

function setLocalStorageByKey(key: string, value: any) {
  if (checkLocalStorage()) {
    window.localStorage.setItem(key, value)
  }
}

function getLocalStorageByKey(key: string) {
  if (checkLocalStorage()) {
    return window.localStorage.getItem(key) || ''
  }
  return ''
}

function deleteLocalStorageByKey(key: string) {
  if (checkLocalStorage()) {
    window.localStorage.removeItem(key)
  }
}

function clearLocalStorage() {
  if (checkLocalStorage()) {
    window.localStorage.clear()
  }
}

const LocalStorage = {
  set: setLocalStorageByKey,
  get: getLocalStorageByKey,
  delete: deleteLocalStorageByKey,
  clear: clearLocalStorage,
}

export default LocalStorage
